// extracted by mini-css-extract-plugin
export default {"root":"Buttons_root__SJcLT","btnView":"Buttons_btnView__G6-Lk","btnDown":"Buttons_btnDown__v6CEz"};